import React from 'react';
import { Bone } from '../Bone/Bone';
import { ProviderCardSkeleton } from '../ProviderCardSkeleton/ProviderCardSkeleton';
import './CatalogSkeleton.css';

/* Local counts, not the catalog's: data/providers.ts would pull the logos into the bundle. */
const CHIPS = [0, 1, 2, 3, 4, 5, 6, 7, 8];
const CARDS = [0, 1, 2, 3, 4, 5];

/** Browse integrations while it loads: heading and hint, the chips, and a group in its panel. */
export function CatalogSkeleton(): React.ReactElement {
  return (
    <div className="integrations-catalog-skeleton">
      <div className="integrations-catalog-skeleton__heading">
        <Bone className="integrations-catalog-skeleton__title" />
        <Bone className="integrations-catalog-skeleton__hint" />
      </div>
      <div className="integrations-catalog-skeleton__chips">
        {CHIPS.map((chip) => (
          <Bone key={chip} className="integrations-catalog-skeleton__chip" />
        ))}
      </div>
      <div className="integrations-catalog-skeleton__panel">
        <Bone className="integrations-catalog-skeleton__group" />
        <div className="integrations-catalog-skeleton__grid">
          {CARDS.map((card) => (
            <ProviderCardSkeleton key={card} variant="catalog" />
          ))}
        </div>
      </div>
    </div>
  );
}
